<template>
    <div id="app">
        <!-- Navigation Bar -->
        <nav class="navbar navbar-expand-lg">
            <div class="container">

                <Link class="navbar-brand" href="/">
                <strong>ICDGP</strong>
                </Link>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav me-auto">
                        <li class="nav-item">
                            <Link class="nav-link" href="/dashboard">Dashboard</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" href="/profile">Profile</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" href="/membership">Membership</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" href="/certificates">Certificates</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link" href="/members">Members</Link>
                        </li>
                    </ul>

                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                                {{ $page.props.auth.user?.first_name || 'User' }} {{ $page.props.auth.user?.last_name || '' }}
                            </a>
                            <ul class="dropdown-menu">
                                <li>
                                    <Link class="dropdown-item" href="/profile">Profile</Link>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li>
                                    <form @submit.prevent="logout" class="d-inline">
                                        <button type="submit" class="dropdown-item" style="border: none; background: none; width: 100%; text-align: left; cursor: pointer;">
                                            Logout
                                        </button>
                                    </form>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <!-- Main Content -->
        <main class="pb-5">
            <slot />
        </main>

        <!-- Footer -->
        <footer class="bg-light mt-auto py-4">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <p class="mb-0">&copy; {{ currentYear }} ICDGP. All rights reserved.</p>
                    </div>
                    <div class="col-md-6 text-end">
                        <p class="mb-0">v1.0.0168</p>
                    </div>
                </div>
            </div>
        </footer>

        <!-- Flash Messages Handler -->
        <FlashMessages />

    </div>
</template>

<script setup>
import { Link, router } from '@inertiajs/vue3';
import { computed } from 'vue';
import FlashMessages from '@/Components/FlashMessages.vue';

const currentYear = computed(() => {
    return new Date().getFullYear();
});

const logout = () => {
    router.post('/logout');
};
</script>

<style scoped>
#app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

main {
    flex: 1;
}

.navbar-brand {
    font-weight: bold;
}

.nav-link.active {
    color: #fff !important;
    font-weight: 500;
}

footer {
    border-top: 1px solid #dee2e6;
    background-image: linear-gradient(180deg, #fdfbfb 0%, #ebedee 100%);
}
</style>
